import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { VenuePageCarouselMode } from "@punchup/data/models";
import { getApiClient } from "@punchup/utils/apiRegistry";
import { CAROUSEL_QUERY_KEY } from "./api";

interface UpdateCarouselModeParams {
  venuePageId: string;
  mode: VenuePageCarouselMode;
  autoRotateDelay?: number | null;
}

interface UpdateCarouselModeResponse {
  data: {
    id: string;
    carousel_mode: VenuePageCarouselMode;
    carousel_auto_rotate_delay: number | null;
  };
}

async function updateVenuePageCarouselMode(
  params: UpdateCarouselModeParams
): Promise<UpdateCarouselModeResponse> {
  const body: { mode: VenuePageCarouselMode; autoRotateDelay?: number | null } =
    { mode: params.mode };
  if (params.autoRotateDelay !== undefined) {
    body.autoRotateDelay = params.autoRotateDelay;
  }
  return getApiClient().patch(
    `/api/v2/manager/venue-pages/${params.venuePageId}/carousel-mode`,
    body
  );
}

/**
 * Hook to update the carousel mode for a venue page
 */
export function useUpdateVenuePageCarouselMode(): UseMutationResult<
  UpdateCarouselModeResponse,
  Error,
  UpdateCarouselModeParams
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateVenuePageCarouselMode,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: [CAROUSEL_QUERY_KEY, variables.venuePageId],
      });
    },
  });
}
